import request from "@/utils/request";

// 列表(主数据列表)
export function loadExpenseCenterListDataApi(data) {
  return request({
    url: "web/expenseCenter/listData",
    method: "post",
    data
  });
}
// 导出
export function loadExpenseCenterExportDataApi(data) {
  return request({
    url: "web/expenseCenter/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateExpenseCenterApi(data) {
  return request({
    url: "web/expenseCenter/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initExpenseCenterApi(data) {
  return request({
    url: "web/expenseCenter/init",
    method: "post",
    data
  });
}

// 获取下拉列表
export function getExpenseCenterListApi(data) {
  return request({
      url: "web/expenseCenter/listSelectData",
      method: "post",
      data
  });
}